module.exports = __webpack_public_path__ + "static/media/9B.8d59c967.png";